<template>
  <div>
    <van-nav-bar
      left-arrow
      title="抬头信息"
      @click-left="onClickLeft"
      :right-text="this.$route.query.operation == 'add' ? '' : '删除'"
      @click-right="onClickRight"
    />
    <div class="img1" />
    <!-- <div style="height: 2px"></div> -->
    <!-- <van-tabs style="margin-top: 10px">
      <van-tab title="企业" name="a"> -->
        <van-form>
          <van-field
            v-model="headerName"
            maxlength="60"
            required
            placeholder="请输入发票抬头信息"
            label="发票抬头"
            onkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')"
            :rules="[{ required: true, message: '请填写抬头名称' }]"
          />
          <van-field
            v-model="identificationNumber"
            required
            label="企业税号"
            placeholder="请输入企业税号信息"
            :rules="[{ required: true, message: '请填写纳税人识别号' },
                     { validator:identValidator, message:'企业税号异常' }]"
          />
          <van-field
            v-model="businessAddress"
            name="地址电话"
            required
            label="地址电话"
            placeholder="地址电话"
            :rules="[{ required: true, message: '请填写企业地址' },
                     { validator:addressValidator,message: '地址电话异常' }]"
          />
          <van-field
            v-model="bankAccount"
            name="银行账号"
            required
            label="银行账号"
            placeholder="银行账号"
            :rules="[{ required: true, message: '请填写银行账号' }]"
          />
          <van-field
            v-model="email"
            required
            label="企业邮箱"
            placeholder="企业邮箱"
            :rules="[{ required: true, message: '请输入企业邮箱' },
                     { validator:emailValidator, message:'邮箱格式异常' }]"
          />
          <!-- <template #input></template> -->
          <!-- <van-field
            v-model="phone"
            required
            clearable
            label="手机号"
            placeholder="请输入手机号"
            :rules="[
              { required: true, message: '请输入手机号' },
              { validator, message: '手机号格式不正确' },
            ]"
          /> -->
          <van-field
            v-model="remarks"
            label="简介/备注"
            placeholder="简介/备注"
          />
          <van-field name="switch" label="设为默认">
            <template #input>
              <van-switch
                v-model="isDefault"
                size="24"
              />
            </template>
          </van-field>
          <div class="button-group">
            <van-button
              v-if="updateHide"
              :loading="loginloading"
              round
              type="danger"
              size="normal"
              style="width: 93%; margin: 2px auto"

              @click="updateUserData(2)"
              >{{ "保存" }}</van-button
            >
            <van-button
              v-if="addHide"
              :loading="loginloading"
              round
              type="danger"
              @click="updateUserData(2)"
              size="normal"
              style="width: 93%; margin: 2px auto"
              >新增</van-button
            >
            <van-button
              :loading="loginloading"
              v-if="this.isState === 'update'"
              round
              type="danger"
              size="normal"
              style="width: 93%; margin: 2px auto"
              @click="realNameAuthentication"
            >
              去实名</van-button
            >
          </div>
        </van-form>
      <!-- </van-tab>
    </van-tabs> -->
    <van-cell-group> </van-cell-group>
  </div>
</template>

<script>
import {
  Button,
  Cell,
  CellGroup,
  Col,
  Dialog,
  Field,
  Form,
  Icon,
  Row,
  Switch,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast,
} from "vant";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [Switch.name]: Switch,
  },
  data() {
    return {
      headerName: "",
      identificationNumber: "",
      businessAddress: "",
      email: "",
      phone: "",
      remarks: "",
      loginloading: false,
      bankAccount: "",
      memTypeQY: 2,
      memTypeGR: 1,
      disableUp: true,
      id: "",
      addHide: false, // 添加操作需要隐藏的控件
      updateHide: false, // 修改操作需要隐藏的控件
      editDisabled: true, // 修改操作控件禁用
      isDefault: "",
      isState: "",
      editId: "",
      fddCustomerId: "",
      authenticationStatus: "",
      certificationNumber: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editId = this.$route.query.id;
      this.isState = this.$route.query.operation;
      if (this.isState === "add") {
        this.addHide = true;
        this.editDisabled = false;
      } else if (this.isState === "update") {
        this.updateHide = true;
        this.editDisabled = true;
        this.$axios
          .get("/memberBusiness/enterprise/" + this.editId + "/enterpriseList")
          .then((data) => {
            this.headerName = data.data.corpName;
            this.email = data.data.corpEmail;
            this.remarks = data.data.corpContent;
            //   this.corpStatus = data.data.corpStatus
            this.isDefault = data.data.isDefault === "1" ? true : false;
            this.identificationNumber = data.data.corpNsrsbh;
            this.businessAddress = data.data.corpDzdh;
            this.bankAccount = data.data.corpYhzh;
            this.memTypeGR = data.data.corpStatus === "1" ? 1 : 2;
            this.memTypeQY = data.data.corpStatus === "1" ? 1 : 2;
            this.fddCustomerId = data.data.fddCustomerId;
            this.authenticationStatus = data.data.authenticationStatus;
            this.certificationNumber = data.data.certificationNumber;
            this.id = data.data.id
          });
      }
    },
    identValidator(val) {
      return /^[a-zA-Z0-9]{15,20}$/.test(val);
    },
    emailValidator(val){
      return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(val);
    },
    addressValidator(val){
      if(val.length<6){
        return false
      }
      return true
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      Dialog.confirm({
        title: "删除",
        message: "是否删除抬头发票",
      })
        .then(() => {
          this.$axios
            .get("/memberBusiness/enterprise/enterprise/" + this.editId)
            .then((data) => {
              Toast(data.message);
              this.$router.push({ path: "/headerList" });
            });
        })
        .catch(() => {
          s;
        });
    },
    realNameAuthentication(){
      
      this.$axios
          .post("/memberBusiness/fdd/smrzUrl", {
            fddCustomerId:this.fddCustomerId,
            id:this.id
          })
          .then((data) => {
            this.certificationNumber = data.message  
            this.$router.push({name :"fddIframe", query: {url: data.data}})
          });
    },
    updateUserData(vals) {
      if (this.isState === "add") {
        this.$axios
          .post("/memberBusiness/enterprise/add", {
            corpName: this.headerName, // 抬头名称
            corpNsrsbh: this.identificationNumber, // 纳税人识别号
            corpDzdh: this.businessAddress, // 企业地址
            corpYhzh: this.bankAccount, // 银行账号
            corpStatus: 1, // 公司状态
            corpContent: this.remarks, // 简介备注
            corpFplx: this.remarks, // 备注
            isDefault: this.isDefault === true ? 1 : 0, // 设为默认
            corpFplx: vals, // 发票类型
            corpEmail: this.email, // 邮箱
          })
          .then((data) => {
            Toast(data.message);
            this.$router.push({ path: "/headerList" });
          });
      } else if (this.isState === "update") {
        this.$axios
          .post("/memberBusiness/enterprise/update", {
            corpName: this.headerName, // 抬头名称
            corpNsrsbh: this.identificationNumber, // 纳税人识别号
            corpDzdh: this.businessAddress, // 企业地址
            corpYhzh: this.bankAccount, // 银行账号
            corpStatus: 1, // 公司状态
            corpContent: this.remarks, // 简介备注
            corpFplx: this.remarks, // 备注
            isDefault: this.isDefault === true ? 1 : 0, // 设为默认
            corpFplx: vals, // 发票类型
            corpEmail: this.email, // 邮箱
            id: this.editId,
            fddCustomerId:this.fddCustomerId,
            authenticationStatus: this.authenticationStatus,
            certificationNumber: this.certificationNumber,
          })
          .then((data) => {
            Toast(data.message);
            if ((data.code = 200)) {
              this.$router.push({ path: "/headerList" });
            }
          });
      }

      //   this.$axios
      //       .post('/common/upDateKpData',
      //           {
      //             memMobileno:this.phone,  // 手机号
      //             memName: this.headerName,// 抬头名称
      //             memWxId: sessionStorage.getItem("openId"), // 微信openid
      //             nsrsbh: this.identificationNumber, // 纳税人识别号
      //             address: this.businessAddress, // 企业地址
      //             memEmail: this.email, // 邮箱
      //             remarks: this.remarks, // 备注
      //             bankAccount: this.bankAccount,
      //             id: this.id
      //           })
      //       .then(data => {
      //         if(data.code==200){
      //           Toast(data.message)
      //         //  localStorage.setItem("accessToken", data.data.obj.token)
      //          // localStorage.setItem("login_data", JSON.stringify(data.data.obj));
      //           this.$router.push({path: '/home'})
      //         }else{
      //           Toast(data.message)
      //         }
      //         this.disableUp = !this.disableUp
      //       })
      //       .catch(erro => {
      //         reject(erro);
      //       });
    },
  },
};
</script>

<style lang="less">
.button-group {
  margin: 15px;
  .van-button {
    margin-top: 10px;
  }
}
.user {
  &-poster {
    width: 100%;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}

.img1 {
  background-size: 100% 100%;
  //background: url('../../assets/img/banner.jpg') center center no-repeat;
  height: 100%;
  position: fixed;
  width: 100%;
}
* {
  touch-action: none;
}
</style>
<style lang="less" scoped>
/deep/ .van-field__body {
  disabled: editDisabled;
}
</style>